var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 440 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.621 32.6163C301.621 32.6163 244.868 0.991111 179.734 25.0002C114.601 49.0092 73.1047 111.545 38.1383 161.346C3.17176 211.147 8.53329 268.737 49.5037 301.523C90.4742 334.309 127.596 302.498 191.412 311.454C255.229 320.409 270.762 332.344 329.575 305.548C388.39 278.753 412.358 195.999 381.473 126.53C350.588 57.0625 301.621 32.6163 301.621 32.6163Z",
    fill: "#F6F2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M424 406C424 414.285 332.443 421 219.5 421C106.557 421 15 414.285 15 406C15 397.715 106.557 391 219.5 391C332.443 391 424 397.715 424 406Z",
    fill: "#BCA3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.536 349.937L357.317 350.059L357.353 349.842C357.539 348.704 358.449 344.377 361.9 340.394C363.727 338.286 366.293 336.982 369.157 336.226C372.021 335.469 375.153 335.267 378.069 335.34C380.983 335.413 383.663 335.759 385.616 336.087C386.592 336.251 387.385 336.411 387.933 336.529C387.96 336.535 387.987 336.54 388.013 336.546C387.833 336.766 387.605 337.04 387.334 337.357C386.577 338.242 385.482 339.464 384.131 340.815C381.424 343.522 377.715 346.718 373.663 348.744C367.215 351.968 360.381 350.575 357.915 349.891L357.716 349.836L357.536 349.937ZM305.519 319.949C305.522 319.949 305.526 319.949 305.53 319.949C306.053 319.949 306.811 319.956 307.742 319.991C309.605 320.059 312.162 320.233 314.935 320.652C317.71 321.072 320.689 321.737 323.404 322.782C326.122 323.828 328.544 325.245 330.238 327.15C335.944 333.571 335.751 339.957 335.519 341.961L335.488 342.23L335.572 342.3L335.338 342.365C334.381 342.633 331.899 343.23 328.938 343.194C325.975 343.157 322.576 342.485 319.734 340.261C316.428 337.674 312.789 332.449 309.953 327.809C308.542 325.5 307.342 323.355 306.494 321.788C306.078 321.02 305.748 320.391 305.519 319.949ZM346.515 364.627H346.999H347.015H347.499H362.995L356.459 405.475H337.225L330.689 364.627H346.515ZM390.713 299.277C390.753 299.281 390.792 299.284 390.828 299.287C390.662 299.676 390.418 300.234 390.103 300.915C389.464 302.294 388.532 304.174 387.364 306.181C385.013 310.222 381.76 314.675 378.065 316.664C371.618 320.135 364.518 319.337 362.667 319.048L362.485 319.019L362.557 318.966L362.542 318.695C362.432 316.727 362.589 310.846 367.504 304.76C368.969 302.947 371.172 301.682 373.704 300.816C376.232 299.951 379.048 299.496 381.693 299.277C384.334 299.059 386.788 299.077 388.581 299.15C389.478 299.186 390.208 299.236 390.713 299.277ZM347.095 267.946C347.152 268.031 347.214 268.125 347.282 268.228C347.661 268.8 348.2 269.629 348.839 270.657C350.117 272.714 351.793 275.562 353.385 278.728C354.978 281.896 356.481 285.37 357.421 288.681C358.365 292.004 358.724 295.103 358.094 297.55C355.838 306.322 348.992 309.842 347.296 310.593L347.013 310.717V310.68L346.671 310.566C344.756 309.932 338.234 307.178 335.803 298.424L335.803 298.424C335.104 295.906 335.444 292.719 336.401 289.3C337.355 285.894 338.903 282.319 340.551 279.06C342.198 275.802 343.938 272.872 345.267 270.756C345.931 269.698 346.491 268.844 346.886 268.256C346.962 268.142 347.031 268.039 347.095 267.946Z",
    fill: "#F4FCBE",
    stroke: "#303826"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.62 237.111H78.4187C70.8398 237.111 64.6963 230.967 64.6963 223.389V53.738C64.6963 46.1592 70.8398 40.0156 78.4187 40.0156H347.62C355.199 40.0156 361.342 46.1592 361.342 53.738V223.389C361.342 230.967 355.199 237.111 347.62 237.111Z",
    fill: "#E9E0FF",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M347.62 237.111H78.4187C70.8398 237.111 64.6963 230.967 64.6963 223.389V53.738C64.6963 46.1592 70.8398 40.0156 78.4187 40.0156H347.62C355.199 40.0156 361.342 46.1592 361.342 53.738V223.389C361.342 230.967 355.199 237.111 347.62 237.111Z",
    fill: "#E9E0FF",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.602 169.164V150.695H189.313V169.164H155.602Z",
    fill: "white",
    stroke: "#303826"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.601 192.16V173.693H189.312V192.16H155.601Z",
    fill: "white",
    stroke: "#303826"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193.842 169.164V150.695H227.554V169.164H193.842Z",
    fill: "white",
    stroke: "#303826"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232.083 146.166V127.699H265.795V146.166H232.083Z",
    fill: "white",
    stroke: "#303826"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M232.084 123.169V104.701H265.796V123.169H232.084Z",
    fill: "white",
    stroke: "#303826"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M232.083 77.1757V62.1992H265.795V77.1757H232.083Z",
    fill: "#BCA3F9",
    stroke: "#303826"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.842 77.1757V62.1992H227.554V77.1757H193.842Z",
    fill: "#BCA3F9",
    stroke: "#303826"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M193.842 192.16V173.693H227.554V192.16H193.842Z",
    fill: "white",
    stroke: "#303826"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M193.842 100.172V81.7051H227.554V100.172H193.842Z",
    fill: "white",
    stroke: "#303826"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M193.842 123.169V104.701H227.554V123.169H193.842Z",
    fill: "white",
    stroke: "#303826"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M193.842 146.166V127.699H227.554V146.166H193.842Z",
    fill: "white",
    stroke: "#303826"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M232.083 192.16V173.693H265.795V192.16H232.083Z",
    fill: "white",
    stroke: "#303826"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8281 100.172V81.7051H112.83V100.172H76.8281Z",
    fill: "white",
    stroke: "#303826"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8281 146.166V127.699H112.83V146.166H76.8281Z",
    fill: "white",
    stroke: "#303826"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8281 169.164V150.695H112.83V169.164H76.8281Z",
    fill: "white",
    stroke: "#303826"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8281 123.169V104.701H112.83V123.169H76.8281Z",
    fill: "white",
    stroke: "#303826"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M308.564 77.1757V62.1992H344.567V77.1757H308.564Z",
    fill: "#BCA3F9",
    stroke: "#303826"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8281 192.16V173.693H112.83V192.16H76.8281Z",
    fill: "white",
    stroke: "#303826"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M270.324 100.172V81.7051H304.036V100.172H270.324Z",
    fill: "white",
    stroke: "#303826"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M232.084 169.164V150.695H265.796V169.164H232.084Z",
    fill: "white",
    stroke: "#303826"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M270.324 169.164V150.695H304.036V169.164H270.324Z",
    fill: "white",
    stroke: "#303826"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M270.324 123.169V104.701H304.036V123.169H270.324Z",
    fill: "white",
    stroke: "#303826"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M270.324 146.166V127.699H304.036V146.166H270.324Z",
    fill: "white",
    stroke: "#303826"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M270.324 192.16V173.693H304.036V192.16H270.324Z",
    fill: "white",
    stroke: "#303826"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M232.083 100.172V81.7051H265.795V100.172H232.083Z",
    fill: "white",
    stroke: "#303826"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M308.564 192.16V173.693H344.567V192.16H308.564Z",
    fill: "white",
    stroke: "#303826"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M270.324 77.1757V62.1992H304.036V77.1757H270.324Z",
    fill: "#BCA3F9",
    stroke: "#303826"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M308.564 169.164V150.695H344.567V169.164H308.564Z",
    fill: "white",
    stroke: "#303826"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M270.324 216.265V196.689H304.036V216.265H270.324Z",
    fill: "white",
    stroke: "#303826"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M308.564 146.166V127.699H344.567V146.166H308.564Z",
    fill: "white",
    stroke: "#303826"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M193.842 216.265V196.689H227.554V216.265H193.842Z",
    fill: "white",
    stroke: "#303826"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M232.084 216.265V196.689H265.796V216.265H232.084Z",
    fill: "white",
    stroke: "#303826"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M308.564 123.169V104.701H344.567V123.169H308.564Z",
    fill: "white",
    stroke: "#303826"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M308.564 216.265V196.689H344.567V216.265H308.564Z",
    fill: "white",
    stroke: "#303826"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8281 216.265V196.689H112.83V216.265H76.8281Z",
    fill: "white",
    stroke: "#303826"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M308.564 100.172V81.7051H344.567V100.172H308.564Z",
    fill: "white",
    stroke: "#303826"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8281 77.1757V62.1992H112.83V77.1757H76.8281Z",
    fill: "#BCA3F9",
    stroke: "#303826"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M117.36 77.1757V62.1992H151.072V77.1757H117.36Z",
    fill: "#BCA3F9",
    stroke: "#303826"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M117.359 169.164V150.695H151.071V169.164H117.359Z",
    fill: "white",
    stroke: "#303826"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M155.601 77.1757V62.1992H189.312V77.1757H155.601Z",
    fill: "#BCA3F9",
    stroke: "#303826"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M155.602 123.169V104.701H189.313V123.169H155.602Z",
    fill: "white",
    stroke: "#303826"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M117.36 192.16V173.693H151.072V192.16H117.36Z",
    fill: "white",
    stroke: "#303826"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M155.601 100.172V81.7051H189.312V100.172H155.601Z",
    fill: "white",
    stroke: "#303826"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M117.36 100.172V81.7051H151.072V100.172H117.36Z",
    fill: "white",
    stroke: "#303826"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M155.601 146.166V127.699H189.312V146.166H155.601Z",
    fill: "white",
    stroke: "#303826"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M117.36 146.166V127.699H151.072V146.166H117.36Z",
    fill: "white",
    stroke: "#303826"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M117.359 216.265V196.689H151.071V216.265H117.359Z",
    fill: "white",
    stroke: "#303826"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M117.359 123.169V104.701H151.071V123.169H117.359Z",
    fill: "white",
    stroke: "#303826"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M155.602 216.265V196.689H189.313V216.265H155.602Z",
    fill: "white",
    stroke: "#303826"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6629 50.9557C95.4269 50.9557 97.6676 48.715 97.6676 45.951C97.6676 43.187 95.4269 40.9463 92.6629 40.9463C89.8989 40.9463 87.6582 43.187 87.6582 45.951C87.6582 48.715 89.8989 50.9557 92.6629 50.9557Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M114.589 45.951C114.589 43.1863 112.348 40.9463 109.585 40.9463C106.82 40.9463 104.58 43.1875 104.58 45.951C104.58 48.7145 106.821 50.9557 109.585 50.9557C112.348 50.9557 114.589 48.7145 114.589 45.951Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7542 49.2144C91.3024 49.2144 90.126 48.038 90.126 46.5862V28.845C90.126 27.3933 91.3024 26.2168 92.7542 26.2168C94.206 26.2168 95.3825 27.3933 95.3825 28.845V46.5862C95.3825 48.038 94.206 49.2144 92.7542 49.2144Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M109.838 49.2144C108.386 49.2144 107.21 48.038 107.21 46.5862V28.845C107.21 27.3933 108.386 26.2168 109.838 26.2168C111.29 26.2168 112.466 27.3933 112.466 28.845V46.5862C112.466 48.038 111.29 49.2144 109.838 49.2144Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M323.436 45.951C323.436 43.1863 321.195 40.9463 318.431 40.9463C315.667 40.9463 313.427 43.1875 313.427 45.951C313.427 48.7145 315.668 50.9557 318.431 50.9557C321.195 50.9557 323.436 48.7145 323.436 45.951Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M335.352 50.9557C338.116 50.9557 340.357 48.715 340.357 45.951C340.357 43.187 338.116 40.9463 335.352 40.9463C332.588 40.9463 330.348 43.187 330.348 45.951C330.348 48.715 332.588 50.9557 335.352 50.9557Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M318.523 49.2144C317.071 49.2144 315.895 48.038 315.895 46.5862V28.845C315.895 27.3933 317.071 26.2168 318.523 26.2168C319.975 26.2168 321.151 27.3933 321.151 28.845V46.5862C321.151 48.038 319.973 49.2144 318.523 49.2144Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M335.607 49.2144C334.155 49.2144 332.979 48.038 332.979 46.5862V28.845C332.979 27.3933 334.155 26.2168 335.607 26.2168C337.058 26.2168 338.235 27.3933 338.235 28.845V46.5862C338.235 48.038 337.057 49.2144 335.607 49.2144Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M205.547 50.9557C208.311 50.9557 210.551 48.715 210.551 45.951C210.551 43.187 208.311 40.9463 205.547 40.9463C202.783 40.9463 200.542 43.187 200.542 45.951C200.542 48.715 202.783 50.9557 205.547 50.9557Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M222.469 50.9557C225.233 50.9557 227.473 48.715 227.473 45.951C227.473 43.187 225.233 40.9463 222.469 40.9463C219.705 40.9463 217.464 43.187 217.464 45.951C217.464 48.715 219.705 50.9557 222.469 50.9557Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M205.638 49.2144C204.186 49.2144 203.01 48.038 203.01 46.5862V28.845C203.01 27.3933 204.186 26.2168 205.638 26.2168C207.09 26.2168 208.266 27.3933 208.266 28.845V46.5862C208.266 48.038 207.09 49.2144 205.638 49.2144Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M222.722 49.2144C221.27 49.2144 220.094 48.038 220.094 46.5862V28.845C220.094 27.3933 221.27 26.2168 222.722 26.2168C224.174 26.2168 225.35 27.3933 225.35 28.845V46.5862C225.35 48.038 224.174 49.2144 222.722 49.2144Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M99 108L84 121",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108L99 120",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M293 85L279 97",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M284 85L293 97",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M178 85L163 98",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M168 85L178 97",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M333 85L318 98",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M323 85L333 97",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 133.566C195.848 133.566 201.249 140.412 201.808 141.917C202.368 143.423 202.769 145.272 202.769 145.272L206.263 147.877C206.728 148.223 206.809 148.886 206.444 149.335L203.782 152.606C203.782 152.606 206.265 160.822 206.136 162.012C206.008 163.203 197.383 166.123 197.383 166.123L196.582 172.418L180.228 172.215L180.166 160.528L173.63 145.251C173.632 145.252 179.523 134.209 195.848 133.566Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M192.994 156.618L195.188 156.373C195.188 156.373 195.806 159.571 198.653 161.082",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M192.994 156.618L195.188 156.373C195.188 156.373 195.806 159.571 198.653 161.082",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M177.142 133.952C177.142 133.952 170.969 134.247 171.008 142.801C171.047 151.356 179.702 159.276 180.169 160.53C180.635 161.784 185.274 161.203 188.536 159.99C191.799 158.777 192.995 156.619 192.995 156.619C192.995 156.619 189.875 152.067 190.506 150.691C191.136 149.314 194.484 150.639 194.484 150.639C194.484 150.639 195.896 149.828 196.463 149.046C197.029 148.265 200.047 144.858 197.953 143.066C195.859 141.274 192.603 140.2 194.05 137.948C195.497 135.697 200.674 133.487 199.153 128.626C197.632 123.765 194.247 123.881 191.423 125.503C188.599 127.124 187.83 121.984 182.339 124.881C176.847 127.778 175.3 132.066 177.142 133.952Z",
    fill: "#303826",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M243.248 134.277C245.985 135.658 252.657 138.371 258.506 139.415C258.506 139.415 250.964 134.305 243.672 133.034C243.034 132.922 242.671 133.985 243.248 134.277Z",
    fill: "#303826",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M241.853 172.95L250.834 149.942C250.834 149.942 247.251 144.139 247.312 142.384C247.373 140.629 252.932 134.333 252.932 134.333C252.932 134.333 253.39 130.902 255.833 132.542C258.277 134.182 257.978 136.943 257.978 136.943C257.978 136.943 260.488 140.545 261.05 141.917C261.611 143.289 256.277 150.876 256.277 150.876C256.277 150.876 255.414 171.733 253 178.949C250.586 186.165 250.061 187.633 248.501 189.743C246.941 191.851 239.499 188.145 239.499 188.145L241.853 172.95Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M200.75 394.966L215.399 400.278C216.833 400.798 217.628 402.462 216.932 403.818C216.734 404.203 216.427 404.522 215.961 404.687C214.096 405.35 194.82 411.98 189.14 409.585C189.14 409.585 187.19 408.671 187.202 406.492C187.23 401.486 188.629 393.602 188.629 393.602C188.629 393.602 195.781 396.939 200.75 394.966Z",
    fill: "#303826",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M216.931 403.818C217.263 403.172 217.249 402.46 216.996 401.832C212.942 403.798 204.344 407.477 196.505 407.629C191.649 407.721 188.855 407.313 187.238 406.84C187.427 408.759 189.139 409.586 189.139 409.586C194.819 411.98 214.095 405.35 215.961 404.688C216.425 404.523 216.732 404.204 216.931 403.818Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M160.216 390.52C160.216 390.52 158.894 402.647 159.608 403.844C160.322 405.04 162.413 405.864 166.039 405.622C169.665 405.379 170.652 402.766 170.981 401.896C171.31 401.025 170.466 393.089 170.439 391.706C170.413 390.324 160.216 390.52 160.216 390.52Z",
    fill: "#303826",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M171.015 399.625C169.899 401.776 168.473 403.154 164.782 403.225C162.119 403.277 160.313 402.387 159.397 401.791C159.395 402.826 159.454 403.587 159.608 403.844C160.322 405.04 162.413 405.864 166.039 405.621C169.665 405.379 170.652 402.766 170.981 401.896C171.078 401.639 171.072 400.761 171.015 399.625Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M208.583 250.959C206.302 252.291 202.221 253.621 197.796 254.804L165.357 247.304C165.357 247.304 163.205 265.497 163.265 268.626C163.325 271.754 164.409 328.067 164.409 328.067L159.995 391.371C159.995 391.371 161.307 394.475 165.061 394.403C168.815 394.331 171.294 393.031 171.294 393.031L185.197 327.158L188.273 397.085C188.273 397.085 190.186 398.926 194.566 398.841C198.946 398.757 200.75 394.966 200.75 394.966C200.75 394.966 202.909 367.871 206.115 348.544C209.321 329.217 209.722 275.866 209.722 275.866L208.583 250.959Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M185.197 327.157L181.638 280.163L173.348 272.187",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M167.82 225.168C168.164 224.067 167.751 222.876 166.796 222.229C163.189 219.783 154.461 214.774 151.676 221.377C151.676 221.377 150.795 223.709 149.976 229.28C149.2 234.562 149.486 270.333 149.518 274.02C149.519 274.223 149.498 274.418 149.453 274.616C149.139 276.01 147.864 282.123 148.749 285.781C149.755 289.928 151.668 293.132 154.926 293.995C158.184 294.859 159.962 291.121 159.455 288.815C158.948 286.51 160.167 284.716 159.659 282.412C159.249 280.549 157.478 275.694 156.813 273.899C156.646 273.448 156.607 272.973 156.699 272.501C157.614 267.79 162.749 241.409 163.146 240.136C163.493 239.036 166.541 229.266 167.82 225.168Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M153.954 286.533C153.954 286.533 158.112 289.43 158.592 292.121",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M155.275 284.113C155.275 284.113 158.566 286.273 159.453 287.966",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M155.875 281.679L157.037 283.307C157.037 283.307 157.624 289.776 159.459 288.815C161.291 287.854 160.215 280.004 160.215 280.004C160.215 280.004 159.284 278.081 156.419 273.507",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M155.875 281.679L157.037 283.307C157.037 283.307 157.624 289.776 159.459 288.815C161.291 287.854 160.215 280.004 160.215 280.004C160.215 280.004 159.284 278.081 156.419 273.507",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M155.667 274.921C156.072 275.6 156.476 279.926 155.493 281.996C154.466 284.159 151.926 287.769 151.926 287.769C151.926 287.769 155.236 290.954 156.761 293.033",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M157.737 182.722L147.059 221.93C147.059 221.93 155.994 229.164 167.1 228.951L174.254 191.779C174.254 191.779 166.227 173.845 157.737 182.722Z",
    fill: "#ECF99E",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M175.431 169.862C175.431 169.862 159.709 177.663 158.236 181.226C157.022 184.161 160.659 204.992 160.729 208.644C160.8 212.297 163.933 243.743 164.781 249.817C165.629 255.892 185.946 258.487 193.695 256.146C201.446 253.803 208.622 252.907 208.584 250.959C208.547 249.01 207.497 232.464 207.923 229.289C208.349 226.114 211.624 202.297 211.624 202.297L241.167 196.179C241.167 196.179 242.533 195.355 242.57 190.007C242.623 182.362 241.793 174.917 241.793 174.917C241.793 174.917 237.239 176.279 230.103 175.647C222.968 175.015 214.52 173.099 213.02 173.523C211.52 173.948 201.293 171.8 197.874 171.379C193.18 170.8 181.22 166.827 175.431 169.862Z",
    fill: "#ECF99E",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIllustration);
export default __webpack_public_path__ + "static/media/calendar_illustration.35d4600cb5be9f2fef08880085797d07.svg";
export { ForwardRef as ReactComponent };